// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__e--Wu","name":"styles_name__2_B_S","phone":"styles_phone__izobj"};